import {FormControl} from '@angular/forms';
import {MatchingPassword} from '../MatchingPassword';

export class Factory {

    // ########################################

    public create(
        keyError: string,
        passwordControl: FormControl,
        confirmPasswordControl: FormControl
    ): MatchingPassword {

        return new MatchingPassword(
            keyError,
            passwordControl,
            confirmPasswordControl
        );
    }

    // ########################################

}